import { useTranslation } from 'react-i18next';

const features = [
  { key: 'organized', icon: 'ri-grid-line' },
  { key: 'sellers', icon: 'ri-shield-check-line' },
  { key: 'qc', icon: 'ri-search-eye-line' },
  { key: 'shipping', icon: 'ri-truck-line' },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
            {t('features.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-6xl mx-auto">
          {features.map((f) => (
            <div
              key={f.key}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-background-100 transition-all"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                <i className={`${f.icon} text-2xl md:text-3xl`} />
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">
                {t(`features.${f.key}`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(`features.${f.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}